import React from 'react'
import styled from 'styled-components';
import Lottie from 'react-lottie'
import LoadingPacman from '../../assets/loading_pacman.json'

const LoadingContent = styled.div`
    width: 100%;
    height: 100%;
`

const LoadingSpinner = () => {

    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: LoadingPacman,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };

    return (
        <LoadingContent>
            <Lottie
                options={defaultOptions}
                height={400}
                width={400}
            />
        </LoadingContent>
    )
}

export default LoadingSpinner;